import { DyCampaignName } from "./types";

export const NO_FEATURE_FLAG_CAMPAIGN = "NO_FEATURE_FLAG_CAMPAIGN";

export const DyCampaignsInfo: {
  [key in DyCampaignName]: {
    featureFlagName: string;
  };
} = {
  [DyCampaignName.POC]: {
    featureFlagName: "dyCampaignPoc",
  },
  [DyCampaignName.RVP]: {
    featureFlagName: "dyCampaignRVP",
  },
  [DyCampaignName.LoqateTesting]: {
    featureFlagName: "dyCampaignLoq",
  },
  [DyCampaignName.Geolocation]: {
    featureFlagName: "dyCampaignGeo",
  },
  [DyCampaignName.CrossSellMVP]: {
    featureFlagName: "crossSellFeatureBasket",
  },
  [DyCampaignName.CrossSellPDP]: {
    featureFlagName: NO_FEATURE_FLAG_CAMPAIGN,
  },
  [DyCampaignName.CrossSellFeatureBasket]: {
    featureFlagName: "dyCampaignABCrossSellFeatureBasket",
  },
  [DyCampaignName.ShopTheLookFeaturePDP]: {
    featureFlagName: NO_FEATURE_FLAG_CAMPAIGN,
  },
  [DyCampaignName.MiniAddToBagCheckoutAndViewbagCTA]: {
    featureFlagName: "dyCampaignABMiniAddToBagCheckoutAndViewbagCTA",
  },
  [DyCampaignName.ApplePayExpressCheckoutAB]: {
    featureFlagName: "dyCampaignABApplePayExpressCheckout",
  },
  [DyCampaignName.HomepageComponents]: {
    featureFlagName: "dyCampaignHomepageComponents",
  },
  [DyCampaignName.SwapCCAndStoreStockOrder]: {
    featureFlagName: NO_FEATURE_FLAG_CAMPAIGN,
  },
  [DyCampaignName.PdpStockAvails]: {
    featureFlagName: NO_FEATURE_FLAG_CAMPAIGN,
  },
  [DyCampaignName.PdpStickyAddToBag]: {
    featureFlagName: NO_FEATURE_FLAG_CAMPAIGN,
  },
};

export const LOGGER_LABEL_PREFIX = "DY";

// See https://dy.dev/docs/page-context
export const DY_PAGE_DATA_EMPTY = [""];

export const DEFAULT_CHOOSE_CAMPAIGN_REQUEST_OPTIONS = {
  isImplicitPageview: false,
  returnAnalyticsMetadata: true,
  isImplicitImpressionMode: true,
  isImplicitClientData: true,
};
